export default "__VITE_ASSET__CZspfdQY__"